import styled from 'styled-components';
import { IC_RIGHT_ARROW } from '../../Assets/images';

export const ClinicNearbyStyled = styled.div`
  width: 100%;
  a {
    color: inherit;
    text-decoration: none;
  }
  .container {
    .title {
      margin-left: 0;
    }
  }

  .clinicSlider {
    width: 100%;

    .slick-list {
      margin: 0 0 0 -8px;
    }

    .item {
      display: flex;
      width: 100%;
      height: 100%;
    }
    .itemBox {
      width: calc(100% - 16px);
      height: 100%;
      min-height: 354px;
      margin: 0px 8px;
      border: 1px solid ${(props) => props?.theme?.color?.lightGray};
      background-color: ${(props) => props?.theme?.color?.white};
      border-radius: 10px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      position: relative;

      .image {
        width: 220px;
        height: 220px;
        min-width: 100%;
        max-width: 100%;
        min-height: 220px;
        margin-bottom: 12px;
        border-radius: 4px 8px 8px 8px;
        background-size: cover;
        background-position: 50% 50%;
        overflow: hidden;

        > div {
          min-width: 100%;
          min-height: 100%;
        }

        @media (max-width: 767px) {
          width: 220px;
          height: 220px;
        }
      }

      .details {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;

        .arrow {
          width: 7px;
          height: 12px;
          background: url(${IC_RIGHT_ARROW.src}) no-repeat 50% 50% / cover;
          position: absolute;
          top: 10px;
          right: 0;
          z-index: 1;
          cursor: pointer;
        }
        .name {
          max-width: 90%;
          font-size: 15px;
          line-height: 19px;
          font-weight: 700;
          color: ${(props) => props?.theme?.text?.dark};
        }

        .type {
          color: ${(props) => props?.theme?.grey?.dark};
          font-size: 12px;
          line-height: 15px;
          font-weight: 500;
          margin-top: 4px;
        }
        .location {
          font-size: 13px;
          line-height: 16px;
          font-weight: 600;
          margin-top: 8px;
          color: ${(props) => props?.theme?.text?.dark};
        }
        .distance {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 12px;
          line-height: 15px;
          margin: 2px 0 6px;
          font-weight: 500;
        }
      }
      .doctors {
        color: ${(props) => props?.theme?.color?.white};
        font-size: 14px;
        line-height: 18px;
        font-weight: 600;
        margin-top: 8px;
        position: absolute;
        background-color: ${(props) => props?.theme?.blue?.dark};
        box-shadow: 0px 4.52174px 4.52174px rgba(0, 0, 0, 0.08);
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        top: 0;
        left: 8px;
        padding: 5px 7px;
      }
    }
  }

  @media (max-width: 820px) {
    .container {
      padding: 16px 0;
    }

    .pb-4 {
      padding-bottom: 0 !important;
    }
  }

  @media (max-width: 767px) {
    .itemBox {
      .image {
        min-width: 100px;
        width: 100px;
        height: 100px;
      }
    }
  }

  @media (max-width: 580px) {
    .itemBox {
      min-height: 370px !important;
    }
  }

  @media (max-width: 480px) {
    .clinicSlider {
      .itemBox {
        margin-bottom: 10px;
        min-height: 270px !important;
        .image {
          margin: 0 0 10px 0;
          width: 151px;
          height: 118px;
          min-height: 118px;
        }
        .details {
          padding: 0;
          text-align: left;
          margin-left: 0px;

          .icon {
            min-width: 14px;
          }
          .addressDesc {
            max-width: calc(100% - 25px);
          }
          .location {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
`;
